import { useNavigate } from "react-router-dom";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/Marquee";
import Services from "@/components/Services";
import ProtectionBanner from "@/components/ProtectionBanner";
import ExplodedPhone from "@/components/ExplodedPhone";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";

export default function Home() {
  const navigate = useNavigate();

  return (
    <>
      <Hero onOrderClick={() => navigate("/beauftragen")} />
      <MarqueeStrip />
      <Services />
      <ProtectionBanner />
      <ExplodedPhone />
      <WhyUs />
      <Testimonials />
      <Faq />
    </>
  );
}
